module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_cancer_right-747072e7ee798c36ab884b5da3dc23bb.png";